export const INVOICE_TEMPLATE_WIDTH = 1023;
export const INVOICE_TEMPLATE_HEIGHT = 1537;
export const INVOICE_TEMPLATE_LAYOUT_STORAGE_KEY = "invoice-template-layout-v1";

export type InvoiceTemplateFieldKey =
  | "invoiceNumber"
  | "invoiceDate"
  | "patientLastName"
  | "patientFirstName"
  | "patientBirthDate"
  | "consultationDate"
  | "consultationType"
  | "subtotal"
  | "total";

export interface InvoiceTemplateFieldLayout {
  x: number;
  y: number;
  fontSize: number;
  align?: "left" | "center" | "right";
  bold?: boolean;
  width?: number;
  lineHeight?: number;
}

export type InvoiceTemplateLayout = Record<InvoiceTemplateFieldKey, InvoiceTemplateFieldLayout>;

export const DEFAULT_INVOICE_TEMPLATE_LAYOUT: InvoiceTemplateLayout = {
  invoiceNumber: { x: 431, y: 292, fontSize: 11, bold: true },
  invoiceDate: { x: 450, y: 328, fontSize: 11, bold: true },
  patientLastName: { x: 104, y: 490, fontSize: 11, bold: true },
  patientFirstName: { x: 127, y: 541, fontSize: 11, bold: true },
  patientBirthDate: { x: 202, y: 592, fontSize: 11 },
  consultationDate: { x: 242, y: 645, fontSize: 11 },
  consultationType: { x: 241, y: 694, fontSize: 10, width: 205, lineHeight: 18 },
  subtotal: { x: 911, y: 997, fontSize: 14, bold: true, align: "right" },
  total: { x: 903, y: 1109, fontSize: 14, bold: true, align: "right" },
};

export const INVOICE_TEMPLATE_FIELD_LABELS: Record<InvoiceTemplateFieldKey, string> = {
  invoiceNumber: "N° facture",
  invoiceDate: "Date d'émission",
  patientLastName: "Nom",
  patientFirstName: "Prénom",
  patientBirthDate: "Date de naissance",
  consultationDate: "Date de consultation",
  consultationType: "Type de consultation",
  subtotal: "Sous-total",
  total: "Total TTC",
};

export const cloneInvoiceTemplateLayout = (layout: InvoiceTemplateLayout): InvoiceTemplateLayout =>
  JSON.parse(JSON.stringify(layout)) as InvoiceTemplateLayout;

export const getDefaultInvoiceTemplateLayout = (): InvoiceTemplateLayout =>
  cloneInvoiceTemplateLayout(DEFAULT_INVOICE_TEMPLATE_LAYOUT);

export const loadInvoiceTemplateLayout = (): InvoiceTemplateLayout => {
  if (typeof window === "undefined") {
    return getDefaultInvoiceTemplateLayout();
  }

  try {
    const raw = window.localStorage.getItem(INVOICE_TEMPLATE_LAYOUT_STORAGE_KEY);
    if (!raw) return getDefaultInvoiceTemplateLayout();

    const parsed = JSON.parse(raw) as Partial<InvoiceTemplateLayout>;
    return {
      ...getDefaultInvoiceTemplateLayout(),
      ...parsed,
    };
  } catch {
    return getDefaultInvoiceTemplateLayout();
  }
};

export const saveInvoiceTemplateLayout = (layout: InvoiceTemplateLayout) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(INVOICE_TEMPLATE_LAYOUT_STORAGE_KEY, JSON.stringify(layout));
};